



















import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { axiosM } from "@/plugins/axios";
import AccountLoginCmp from "./accountLoginCmp.vue";
@Component({
  components: {
    AccountLoginCmp
  }
})
export default class LoginView extends Vue {
  private cState: "account" | "fast" = "account";
}
